import { render, staticRenderFns } from "./thisWeekList.vue?vue&type=template&id=8a1719c8&scoped=true&"
import script from "./thisWeekList.vue?vue&type=script&lang=js&"
export * from "./thisWeekList.vue?vue&type=script&lang=js&"
import style0 from "./thisWeekList.vue?vue&type=style&index=0&id=8a1719c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1719c8",
  null
  
)

export default component.exports